import { useSearchParams } from "react-router-dom";
// components
import { Shareholder } from "../../../../pages";
import { Drawer } from "@mui/material";
// redux / data
// constants
import { URL_PARAMS } from "../../../../constants";

const ShareholderDrawer = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const shareholderId = searchParams.get(URL_PARAMS.sid);
  const open = !!shareholderId;

  const onClose = (_: unknown, reason: string) => {
    if (reason === "backdropClick") {
      searchParams.delete(URL_PARAMS.sid);
      setSearchParams(searchParams);
    }
  };

  return (
    <Drawer
      anchor="right"
      variant="temporary"
      open={open}
      ModalProps={{
        BackdropProps: {
          sx: { backgroundColor: "transparent" },
        },
      }}
      onClose={onClose}
      data-testid="shareholder-drawer"
      PaperProps={{ elevation: 5 }}
      sx={{
        ".MuiDrawer-paper.MuiPaper-root": {
          width: "600px",
          backgroundColor: "#F0F0F0",
          boxShadow:
            "0px 4px 4px rgba(0, 0, 0, 0.05), 0px 3px 18px rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <Shareholder asDrawer />
    </Drawer>
  );
};

export default ShareholderDrawer;
